<template>
  <div class="box" :class="{ 'box--adaptive-rem': isArkAdaptiveRem }">
    <common-title titleName="会员权益" :isAPPShow="true" />
    <div class="member__top" v-if="!(isMini)"></div>
    <tabs v-model="currentIndex" swipeable line-height="0">
      <tab v-for="(item, index) in benefits" :key="index">
        <template #title>
          <div class="benefits__nav">
            <div class="benefits__nav-icon-wrap">
              <img class="benefits__nav-img" :src="item.icon" alt="">
              <img
                v-if="item.badgeIcon"
                class="benefits__nav-badge"
                referrerpolicy="no-referrer"
                :src="item.badgeIcon"
                alt=""
              >
            </div>
            <span class="benefits__nav-title">{{ item.title }}</span>
          </div>
        </template>
        <div class="benefits__content" v-html="item.faq"></div>
      </tab>
    </tabs>
  </div>
</template>
<script>
import { Tabs, Tab } from 'vant';
import { getNewMemberBenefits } from '@/api/member/index';

// 高阶卡(25) / 尊享卡(30) 权益角标（与会员中心一致）
const BENEFIT_BADGE_VIP =
  'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/svip.png';
const BENEFIT_BADGE_SVIP =
  'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/vip.png';

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      currentIndex: 0,
      isApp: this.$root.$data.isApp || false,
      isMini: this.$root.miniprogram || false,
      benefits: [],
      activeTab: null,
      isArkAdaptiveRem: false,
    };
  },
  mounted() {
    this.updateArkAdaptiveRem();
    window.addEventListener('resize', this.updateArkAdaptiveRem, false);
    window.addEventListener('orientationchange', this.updateArkAdaptiveRem, false);
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateArkAdaptiveRem, false);
    window.removeEventListener('orientationchange', this.updateArkAdaptiveRem, false);
  },
  methods: {
    updateArkAdaptiveRem() {
      this.isArkAdaptiveRem = !!(window.isArkAdaptiveRemEnabled && window.isArkAdaptiveRemEnabled());
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.init();
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },
    /**
     * 角标规则（与会员中心 getBenefitBadgeIcon 一致）：
     * - [20] / [20,25,30]：通用或仅基础 → 无角标
     * - 含 25 不含 30（如 [25]、[20,25]）→ 高阶卡角标
     * - 含 30 不含 25（如 [30]、[20,30]）→ 尊享卡角标
     * - [25,30]：从高阶起 → 高阶卡角标
     */
    getBenefitBadgeIcon(memberLevels) {
      if (!Array.isArray(memberLevels) || !memberLevels.length) return '';
      const levels = memberLevels.map(Number);
      const has20 = levels.includes(20);
      const has25 = levels.includes(25);
      const has30 = levels.includes(30);

      if (has20 && has25 && has30) return '';
      if (has20 && !has25 && !has30) return '';
      if (has30 && !has25) return BENEFIT_BADGE_SVIP;
      if (has25 && !has30) return BENEFIT_BADGE_VIP;
      if (has25 && has30 && !has20) return BENEFIT_BADGE_VIP;
      return '';
    },
    // mode不要删除 不然会报错
    // eslint-disable-next-line no-unused-vars
    async init(mode) {
      const { activeTab, index } = this.$route.query;
      this.activeTab = Number(activeTab);
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      try {
        const data = await getNewMemberBenefits();
        this.benefits = (data || []).map((item) => {
          const { value, remark } = item;
          let parsed = {};
          try {
            parsed = JSON.parse(remark || '{}') || {};
          } catch (e) {
            parsed = {};
          }
          const { title, icon, memberLevels } = parsed;
          return {
            title,
            icon,
            faq: value,
            memberLevels: memberLevels || [],
            badgeIcon: this.getBenefitBadgeIcon(memberLevels),
          };
        });
        this.$nextTick(() => {
          this.currentIndex = Number(index) || 0;
        });
      } finally {
        this.$toast.clear();
      }
    },
  },
  async created() {
    this.init();
  },

};
</script>

<style lang="scss" scoped>
.box {
  width: 750px;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  overflow-x: hidden;
  background: rgba(247, 248, 252, 1);
}

.member__top {
  flex-shrink: 0;
  height: 100px;
}

::v-deep .van-tabs__line {
  display: none;
}

.van-tabs {
  min-height: auto;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  flex-shrink: 0;
  height: 1.76rem;
  background: #fff;
}

::v-deep .van-tabs--line .van-tabs__nav--line {
  height: 100%;
  padding-bottom: 0;
}

::v-deep .van-tabs--line .van-tab {
  align-items: flex-start;
  padding-top: 0.16rem;
}

::v-deep .van-tabs--line .van-tabs__content {
  height: auto;
  min-height: 0;
  overflow: visible;
  background: rgba(247, 248, 252, 1);
}

::v-deep .van-tabs--line .van-tabs__track {
  height: auto;
}

::v-deep .van-tabs--line .van-tabs__content .van-tab__pane {
  height: auto;
  min-height: 0;
  overflow: visible;
  background: rgba(247, 248, 252, 1);
}

::v-deep .van-tabs--line .van-tabs__content .van-tab__pane-wrapper:not(.van-tab__pane-wrapper--inactive) {
  height: auto;
  min-height: 0;
  overflow: visible;
}

::v-deep  .van-tab--active {
  .benefits__nav-title {
    color: #ff7f41;
  }
}

::v-deep .van-tabs--line .van-tabs__content .benefits__content {
  margin-top: 22px;
  padding: 36px 36px 85px;
  overflow: visible;
  background-color: #fff;

  img {
    max-width: 100%;
  }
}

.benefits__nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  &-icon-wrap {
    position: relative;
    flex-shrink: 0;
    width: 72px;
    height: 72px;
  }

  &-img {
    display: block;
    width: 72px;
    height: 72px;
  }

  &-badge {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 47px;
    height: 20px;
    margin: 0 auto;
    pointer-events: none;
  }

  &-title {
    margin-top: 11px;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 31px;
    white-space: nowrap;
  }
}

.box--adaptive-rem {
  ::v-deep .van-tabs--line .van-tabs__wrap--scrollable .van-tabs__nav {
    overflow-x: auto;
    overflow-y: hidden;
  }

  ::v-deep .van-tabs--line .van-tabs__wrap--scrollable .van-tabs__nav--complete {
    padding-right: 0.24rem;
    padding-left: 0.24rem;
  }

  ::v-deep .van-tabs--line .van-tabs__wrap--scrollable .van-tab {
    flex: 0 0 1.706667rem;
    width: 1.706667rem;
    padding-right: 0.133333rem;
    padding-left: 0.133333rem;
  }
}
</style>
